import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useFetch, useNotifications, useAuthentication } from '@/hooks';
import configHelper from '@/helpers/configHelper';
import languageHelper from '@/helpers/languageHelper';
import Notification from './components/molecules/Notification.vue';
import VerifyLogin from './views/VerifyLoginView.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const i18n = useI18n({ useScope: 'global' });
const { fetchApi: fetchPDBApi } = useFetch(configHelper.PDB_API);
const { isLoading: authIsLoading } = useAuthentication();
const language = languageHelper.getLanguage();
const {
  notifications,
  removeNotification,
  showNotification,
  clearNotificationTimer,
  restartNotificationTimer,
} = useNotifications();

onMounted(async () => {
  i18n.locale.value = language;

  document.title = i18n.t('title');

  try {
    const response = await fetchPDBApi<{ [key: string]: string }>(
      `/productdata/translate/${language}/context/download/layout/json`,
      {},
    );
    i18n.mergeLocaleMessage(language, response);
  } catch (error) {
    showNotification(i18n.t('genericError') + i18n.t('loadingLanguageError'), 'error');
    console.error(error);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(authIsLoading))
      ? (_openBlock(), _createBlock(VerifyLogin, { key: 0 }))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
    _createVNode(Notification, {
      notifications: _unref(notifications),
      onClose: _unref(removeNotification),
      onStopTimer: _unref(clearNotificationTimer),
      onRestartTimer: _unref(restartNotificationTimer)
    }, null, 8, ["notifications", "onClose", "onStopTimer", "onRestartTimer"])
  ], 64))
}
}

})